import React, { useState, useEffect, useContext } from 'react';
import { PropTypes } from 'prop-types';
import Icon from '../Icon';
import { NavLink } from 'react-router-dom';
import { FitinsurAPI, MessageCenter } from 'utils';
import Colors from 'constants/Colors';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import { GlobalLoaderContext } from 'store/context';
import { Container, Content, Photo, Title, List, Item, Topo, Name, Remember, Settings, SubTitle, ElipseIcon } from './styles';


const fitinsur = new FitinsurAPI();
const mc = new MessageCenter();
const propTypes = {
  user: PropTypes.any
};

export default function Profile({ user }) {

  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);

  const formatDate = (date) => {
    let dt = new Date(date);
    if (!dt) {
      return '';
    }
    let dtLocale = dt.toLocaleDateString("en", { year: 'numeric', month: 'long', day: 'numeric' }).replace(',', '').split(' ')
    console.log(dtLocale);
    return `${dtLocale[0]} ${dtLocale[1]}${parseInt(dtLocale[1]) === 1 ? 'st' : 'th'} ${dtLocale[2]}`;
  }

  return (
    <Container>
      <Content>
        <Topo>
          <Photo>
            <Icon name="user-gray" />
            <Icon name="check-ok-green" />
          </Photo>
          <Name>{user.name}</Name>
        </Topo>

        <List>
          {/* <NavLink to="/policies">
            <Item>
              <ElipseIcon name="policies" />
              <p>{user.policies}</p>
              <span>Apolices</span>
            </Item>
          </NavLink> */}
          <NavLink to="/quotes">
            <Item>
              <ElipseIcon name="enquiries" />
              <p>{user.enquiries}</p>
              <span>Cotações</span>
            </Item>
          </NavLink>
        </List>
        {/*
        <Title>Lembretes</Title>
        <Remember>
          user.remember.map((item, index) => (
        <List>
            <Item key={index}>
              <Icon name="calendarTransp" />
              <span>{item.nmClient}</span>
              <p>{formatDate(item.aniversaryDate)}</p>
            </Item>
            )
          </List>
          )
          <List>
            <Item>
              <Icon name="calendarTransp" />
              <span>Renovacao</span>
              <p>2R288347RCP</p>
            </Item>
          </List>
        </Remember>
            */}
      </Content>
      <Settings>
        <SubTitle>Configurações</SubTitle>
        <List>
          <NavLink to="/change-password"><Item><Icon name="user" />Mudar Senha</Item></NavLink>
          <NavLink to="/login"><Item><Icon name="logout" />Sair</Item></NavLink>
        </List>
      </Settings>
    </Container>
  );
}
